module.exports = "<div class=\"lds-dual-ring\"></div>"